namespace Matrix.Rebalancer {
    export interface TaskTypeForm {
        TaskTypeCode: Serenity.StringEditor;
        Name: Serenity.StringEditor;
        SessionScope: Serenity.BooleanEditor;
        AutoComplete: Serenity.BooleanEditor;
        RequiresReview: Serenity.BooleanEditor;
        CanAdd: Serenity.BooleanEditor;
        DefaultProperties: Serenity.TextAreaEditor;
        TaskMap: InstructionTaskMapGrid;
        Properties: TaskTypePropertiesGrid;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        Version: StaticTextBlock;
    }

    export class TaskTypeForm extends Serenity.PrefixedContext {
        static formKey = 'Rebalancer.TaskType';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!TaskTypeForm.init)  {
                TaskTypeForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.BooleanEditor;
                var w2 = s.TextAreaEditor;
                var w3 = InstructionTaskMapGrid;
                var w4 = TaskTypePropertiesGrid;
                var w5 = StaticTextBlock;
                var w6 = ReadOnlyDateTime;

                Q.initFormType(TaskTypeForm, [
                    'TaskTypeCode', w0,
                    'Name', w0,
                    'SessionScope', w1,
                    'AutoComplete', w1,
                    'RequiresReview', w1,
                    'CanAdd', w1,
                    'DefaultProperties', w2,
                    'TaskMap', w3,
                    'Properties', w4,
                    'CreatedBy', w5,
                    'CreatedWhen', w6,
                    'UpdatedBy', w5,
                    'UpdatedWhen', w6,
                    'Version', w5
                ]);
            }
        }
    }
}
